import { useState, useEffect } from 'react';
import { Devotion } from '../types';
import { getDevotions } from '../lib/devotions';
import { supabase } from '../lib/supabase';

export function useDevotionsData() {
  const [devotions, setDevotions] = useState<Devotion[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function loadDevotions() {
      try {
        setIsLoading(true);
        setError(null);
        const data = await getDevotions();
        setDevotions(data);
      } catch (err: any) {
        console.error('Error loading devotions:', err);
        setError(err.message || 'Failed to load devotions');
      } finally {
        setIsLoading(false);
      }
    }

    loadDevotions();

    // Subscribe to changes
    const subscription = supabase
      .channel('devotions_changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'devotions'
        },
        () => {
          // Reload devotions when changes occur
          loadDevotions();
        }
      )
      .subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return { devotions, isLoading, error };
}